import { render } from "./PantryDropdownList.vue?vue&type=template&id=e6cdd684&scoped=true&ts=true"
import script from "./PantryDropdownList.vue?vue&type=script&lang=ts"
export * from "./PantryDropdownList.vue?vue&type=script&lang=ts"

import "./PantryDropdownList.vue?vue&type=style&index=0&id=e6cdd684&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6cdd684"]])

export default __exports__